import { useUser } from '../redux/reducer/user';

export const useCreateShareLink = () => {
  const {
    profile: { uid, shareImageHash },
  } = useUser();

  return () => `${location.origin}/api/share/${uid}/${shareImageHash}/`;
};
